<div class="subscription-dialog">
    <div class="subscription-dialog__header">
        <h2>{{ title }}</h2>
    </div>

    <div class="subscription-dialog__message">
        <p>{{ description }}</p>
    </div>

    <ul class="subscription-dialog__list">
        <li>Free Tier includes 50,000 tokens each month.</li>
        <li>Premium includes 1,000,000 tokens per billing cycle.</li>
        <li>Tokens cover understanding your question, generating SQL, and building the answer and chart.</li>
        <li>Running existing SQL again only refreshes the data and does not use tokens.</li>
    </ul>

    <div class="subscription-dialog__actions">
        <button class="--subscription-button" type="button" (click)="close()">Maybe later</button>
        <button class="--subscription-button --primary" type="button" (click)="upgrade()">Upgrade plan</button>
    </div>
</div>
